import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import './tools.css'
import { isIOs, isMobile, getVideo } from '../../misc/selectors'
import { createAction } from 'redux-actions'
import { EDIT_USER, loadFile, extractFromUrl, createVideoFromFile, CREATE_TEMP_VIDEO, cancel } from '../../actions'
import { canPlayVideoFile } from '../../misc/utilities'
import VideoProgress from '../../misc/videoProgress/VideoProgress.js'

const mapStateToProps = (state, ownProps) => {
  const { videos, me, tools } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
    action: ownProps.action
  }
}

class Tool extends Component {
  urlInput = React.createRef();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.url != prevProps.url) {
      this.gotUrl(this.props.url)
    }
  }

  gotUrl(url) {
    browserHistory.push(`/clipper?url=${url}`)
  }

  render() {
    const {dispatch, tempVideo, action } = this.props
    const self = this
    return (
      <div className="tool clipper-tool">
        <div className="header">
            <h1>Clip from URL</h1>
            <p>Create video clips in seconds using the Streamable Clipper tool.</p>
        </div>
        {tempVideo ?
          <VideoProgress video={tempVideo} onCancel={_ => dispatch(cancel(tempVideo))} />
        : ''}
        <form
          className="form start-form"
          onSubmit={(e) => {
            e.preventDefault()
            self.gotUrl(this.urlInput.current.value)
          }}
        >
          <div className="upload-pane">
            <input type="submit" style={{ visibility: 'hidden', position: 'absolute' }} />
            <div className="url-picker">
              <input
                className="form-control"
                id="primary-url-input"
                type="text"
                placeholder="Paste a video URL"
                autoComplete="off"
                ref={this.urlInput}
                onPaste={(e) => {
                  let targetInput = e.target
                  setTimeout(() => {
                    self.gotUrl(targetInput.value)
                  }, 0)
                }}
              />
            </div>
          </div>
          <div className="sample">
            <span>Don't have a video handy? <Link to={`/clipper?url=https://streamable.com/z1plzy`}>Try a sample video →</Link></span>
          </div>
        </form>
        <div className="info-section">
          <p>This is a free tool from <Link to="/">Streamable</Link>, the video hosting service for online creatives that's loved by over 50 million users across the globe.</p>
          <p>Clip video from YouTube, Twitter, and hundreds of other sites. It's free to use for videos up to 10 minutes long — no gimmicks, no watermarks, no sign-up required. A <Link to="/upgrade">free trial</Link> is available for larger files.</p>
        </div>
        <div className="preview-section">
          <img src="https://statics.streamable.com/static/landing/editor.jpg"/>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Tool)
